import { gql } from "@apollo/client"

export const DELETE_SAVED_CARD = gql`
  mutation deleteSavedStripeCard($id: String!){
    deleteSavedStripeCard(id: $id){
      success
    }
  }
`
